'use client';

import { useRouter } from 'next/navigation';
import type { PlayersLeaderboardDtoPaginatedList } from '@/api/backoffice-schemas';
import { SplitPageLayout } from '@/components/layout/SplitPageLayout';
import type { SupportedGame } from '@/config/supportedGames';
import { PICKEMS_SPONSOR } from '@/constants/sponsors';
import { PickemsLeaderboardRewards } from './PickemsLeaderboardRewards';
import { PickemsLeaderboardTable } from './PickemsLeaderboardTable/PickemsLeaderboardTable';
import { PickemsLeaderboardTopWinners } from './PickemsLeaderboardTopWinners';

export const PickemsLeaderboard = ({
  data,
  topWinnersData,
  game,
  rewardsNotice,
}: {
  data: PlayersLeaderboardDtoPaginatedList;
  topWinnersData: PlayersLeaderboardDtoPaginatedList;
  game: SupportedGame;
  rewardsNotice: string;
}) => {
  const router = useRouter();
  function onPageChange(page: number): void {
    router.push(`/${game}/pickems/leaderboard?page=${page}`);
  }

  return (
    <div className="flex w-full flex-col">
      <PickemsLeaderboardTopWinners
        data={topWinnersData}
        poweredBy={PICKEMS_SPONSOR}
      />
      <SplitPageLayout>
        <PickemsLeaderboardTable data={data} onPageChange={onPageChange} />

        <PickemsLeaderboardRewards rewardsNotice={rewardsNotice} />
      </SplitPageLayout>
    </div>
  );
};
